import { cloneElement as e, isValidElement as t } from "react";
import { Fragment as n, jsxs as r } from "react/jsx-runtime";
//#region src/utils/appendToChildren.tsx
var i = (i, a, o = !1) => o && t(i) ? e(i, void 0, /* @__PURE__ */ r(n, { children: [i.props.children, a] })) : /* @__PURE__ */ r(n, { children: [i, a] });
//#endregion
export { i as appendToChildren };
